@if (status()) {
  <app-card-badge class="badge" [color]="statusStyle()?.color">
    {{ statusStyle()?.name }}
  </app-card-badge>
}
